<template>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="演员名称">
          <el-input v-model="formInline.name" placeholder="演员名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="演员类型">
          <el-select
            v-model="formInline.type"
            placeholder="请选择演员类型"
            clearable
          >
            <el-option label="自定义" :value="0"></el-option>
            <el-option label="女优" :value="1"></el-option>
            <el-option label="网黄" :value="2"></el-option>
            <el-option label="博主" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-button @click="search" :loading="loading">查询</el-button>
        <el-button
          v-has="'/api/vlogger/create'"
          type="primary"
          @click="
            addFrom = !addFrom;
            dialogType = 'add';
            data = {};
          "
          >新增</el-button
        >
        <el-button @click="refesh">刷新</el-button>
      </el-form>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          prop="id"
          label="演员ID"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="演员名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="type"
          label="演员类型"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.type === 1 ? "女优" : scope.row.type === 2 ? "网黄" : scope.row.type === 3 ? "博主" : "自定义" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="video_count"
          label="视频数"
          align="center"
        >
            <template slot-scope="scope">
                <el-button type="text" @click="toVideo(scope.row)">{{ scope.row.video_count }}</el-button>
            </template>
        </el-table-column>
        <el-table-column
          prop="post_count"
          label="帖子数"
          align="center"
        >
            <template slot-scope="scope">
                <el-button type="text" @click="toVideo(scope.row)">{{ scope.row.post_count }}</el-button>
            </template>
            </el-table-column>
        <el-table-column
          prop="pic_count"
          label="图集数"
          align="center"
        >
            <template slot-scope="scope">
                <el-button type="text" @click="toVideo(scope.row)">{{ scope.row.pic_count }}</el-button>
            </template>
        </el-table-column>
        <el-table-column
          prop="create_by"
          label="创建者"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="edit_by"
          label="编辑者"
          align="center"
        ></el-table-column>
        <!-- <el-table-column fixed prop="status" label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.status === true ? "正常" : "禁用" }}
          </template>
        </el-table-column> -->
        <el-table-column
          prop="create_time"
          label="创建时间"
          align="center"
        >
            <template slot-scope="scope">
                {{ scope.row.create_time * 1000 | changeDate }}
            </template>
        </el-table-column>
  
        <el-table-column fixed="right" label="操作" align="center" width="140">
          <template slot-scope="scope">
            <!-- <el-button
              @click="edit(scope.row, 'disabled')"
              type="text"
              size="small"
              >查看</el-button
            > -->
            <el-button
              @click="toVideo(scope.row)"
              type="text"
              size="small"
              >查看</el-button
            >
            <el-button
              type="text"
              @click="edit(scope.row)"
              v-has="'/api/actor/update'"
              size="small"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="deleteData(scope.row)"
              v-has="'/api/actor/batch/delete'"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="bottom">
        <div class="page">
          <el-pagination
            :page-sizes="[10, 25, 50, 100]"
            :current-page="formInline.page"
            :page-size="formInline.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
            v-if="total > 10"
            @size-change="changeSize"
            @current-change="changeCurrent"
          ></el-pagination>
        </div>
      </div>
      <addForm
        :show="addFrom"
        :dialogType="dialogType"
        :disabled-type="disabled"
        :data="data"
        @clearData="clearData"
      ></addForm>
    </div>
  </template>
  
  <script>
  import API from "@/api";
  import addForm from "./components/addForm.vue";

  export default {
    name: "manage",
    components: { addForm },
    data() {
      return {
        addFrom: false,
        tableData: [],
        loading: false,
        disabled: false,
        formInline: {
          name: "",
          type: '',
          id: "",
          page: 1,
          size: 10,
        },
        dialogType: "add",
        data: {},
        total: 0,
        isRefesh: true,
      };
    },
    created() {
      let listRule = "/api/actor/list";
      let obj = JSON.parse(
        JSON.parse(JSON.stringify(localStorage.getItem("btnPower")))
      );
      if (obj[listRule]) {
        this.isRefesh = true;
        this.getDataList();
      } else {
        this.isRefesh = false;
      }
    },
    methods: {
      refesh() {
        this.isRefesh ? this.getDataList() : "";
      },
      async getDataList() {
        this.loading = true;
        const { data, code } = await API.getActorList(this.formInline);
        console.log(data);
        if (!code) {
          this.tableData = data.data;
          this.total = data.pagination.count;
          this.tableData.forEach((item) => {
            if (item.last_login_time) {
              const timestampCreate = item.last_login_time * 1000;
              const dateCr = new Date(timestampCreate);
              item.last_login_time = dateCr.toLocaleString();
            } else {
              item.last_login_time = "无";
            }
          });
          this.loading = false;
        } else {
          this.tableData = [];
          this.loading = false;
        }
      },
      edit(data, type) {
        this.addFrom = true;
        type ? (this.dialogType = "look") : (this.dialogType = "edit");
        this.data = JSON.parse(JSON.stringify(data));
        this.disabled = !!type;
      },
      search() {
        this.formInline.page = 1;
        this.getDataList();
      },
      closeAdd() {
        this.addFrom = false;
        this.getDataList();
      },
      async updateData(row) {
        await API.updateUser(row).then(() => {
          this.getDataList();
        });
      },
      clearData() {
        this.addFrom = false;
      },
      // 分页条数改变回调
      changeSize(size) {
        this.formInline.size = size;
        this.getDataList();
      },
      // 分页页码改变回调
      changeCurrent(number) {
        this.formInline.page = number;
        this.getDataList();
      },
      changeData(row) {
        let list = [];
        if (row.product) {
          list = row.product.map((v) => v.product_name);
        }
        return list.join(",");
      },
      toVideo(row) {
        this.$router.push(`/medium/video?actor_name=${row.name}`);
      },
      deleteData(row) {
        this.$confirm('确定删除该演员吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          API.deleteActor({
            ids: [row.id]
          }).then(() => {
            this.getDataList();
          });
        });
      }
    },
  };
  </script>
  
  <style scoped>
  .action-bar {
    display: flex;
  }
  </style>
  